import QuestionnaireList from './QuestionnaireList'

export {
  QuestionnaireList
}


// WEBPACK FOOTER //
// ./src/components/QuestionnaireList/index.js